import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { StorageService } from 'src/app/services/auth/storage.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent {
  interval: any;
  seconds = 3;
  constructor(
    private router: Router,
    private permissionsService: NgxPermissionsService
  ) {
    this.permissionsService.flushPermissions();
    StorageService.signOut();
    this.interval = setInterval(() => {
      this.seconds--;
      if (!this.seconds) {
        clearInterval(this.interval);
        this.router.navigate(['/login']);
      }
    }, 1000);
  }
}
